import React from 'react';
import Button from '@atlaskit/button';
import { GetUpdatePaymentMethodLink } from '../../get-update-payment-method-link';
import { Maybe } from '@css-xp/graphtypes';
import './generate-payment-link.scss';

interface Props {
  updatePaymentMethodLink: Maybe<string> | undefined;
  stacked?: boolean;
}

const GeneratePaymentLink = ({ updatePaymentMethodLink, stacked = false }: Props) => {
  const [copyableFieldsVisible, setCopyableFieldsVisible] = React.useState<boolean>(false);
  const linkToUpdatePaymentMethod: string = updatePaymentMethodLink ?? '';
  return (
    <div className="generate-payment-link" data-testid="generate-payment-link">
      <h2>Payment method</h2>
      <p>Share payment method link with the billing admin so they can add payment details.</p>
      <div className="cta-container">
        <Button
          appearance="primary"
          shouldFitContainer={false}
          onClick={() => {
            setCopyableFieldsVisible((flag) => !flag);
          }}
        >
          Get payment method link
        </Button>
      </div>
      {copyableFieldsVisible && (
        <GetUpdatePaymentMethodLink
          updatePaymentMethodLink={linkToUpdatePaymentMethod}
          jiraMarkupLabel="Payment link with Jira markup e.g. [link title|http://example.com]"
          basicLinkLabel="Payment link"
          stacked={stacked}
        />
      )}
    </div>
  );
};

export default GeneratePaymentLink;
